/**
 * BranchConvenienceSection 컴포넌트
 * 작성자: AI Assistant
 * 설명: 편의시설(아이콘, 텍스트) 리스트를 렌더링합니다.
 * props:
 *   - convenience: 편의시설 문자열 배열
 */
import { CONVENIENCE_KOREAN_MAP, ICON_CONVENIENCE_MAP } from '@/constants';
import Image from 'next/image';

interface BranchConvenienceSectionProps {
  convenienceTag?: string[];
}

export default function BranchConvenienceSection({
  convenienceTag,
}: BranchConvenienceSectionProps) {
  // 편의시설이 없으면 섹션 전체를 숨김
  if (!convenienceTag || convenienceTag.length === 0) {
    return null;
  }

  // 편의시설 데이터 처리 함수
  const getConvenienceData = (title: string) => {
    // 한글 번역이 있으면 사용, 없으면 원본 사용
    const koreanTitle = CONVENIENCE_KOREAN_MAP[title] || title;

    // 아이콘 찾기 (원본 제목이나 한글 제목으로)
    const iconPath =
      ICON_CONVENIENCE_MAP[title] || ICON_CONVENIENCE_MAP[koreanTitle];

    return {
      title: koreanTitle,
      iconPath: iconPath || '/images/icons/icon_convenience.svg', // 기본 아이콘
    };
  };

  return (
    <div className="desktop:flex desktop:pb-9 gap-4 pb-7">
      <div className="desktop:w-[100px] desktop:items-start desktop:pb-5 flex pb-4">
        <Image
          src="/images/icons/icon_convenience.svg"
          alt="편의시설"
          width={20}
          height={20}
        />
        <span className="typo-20 text-level-3 pl-2 font-bold">편의시설</span>
      </div>
      <div className="desktop:pl-6 flex gap-3">
        {convenienceTag.map((title) => {
          const { title: displayTitle, iconPath } = getConvenienceData(title);

          return (
            <div
              key={title}
              className="flex h-[82px] w-[100px] flex-col items-center justify-center rounded-[5px] border border-[#DDDDDD] bg-white py-4"
            >
              <Image
                src={iconPath}
                alt={displayTitle}
                width={30}
                height={30}
                onError={(e) => {
                  // 이미지 로딩 실패 시 기본 아이콘으로 대체
                  const target = e.target as HTMLImageElement;
                  target.src = '/images/icons/icon_convenience.svg';
                }}
              />
              <span className="text-[16px] font-semibold text-[#333333]">
                {displayTitle}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
